<style media="print" type="text/css">
@page {
  /*size: A5 landscape;*/
}

.page {
  /*page-break-after: always !important;*/
  /*page-break-inside: auto !important;*/
  /*page-break-before: always;*/
}
</style>


<template>
  <div style="">
    <!-- type==3-->
    <v-btn
        v-if="btn_type==1"
        :disabled="shipment_id_list.length>1?false:true"
        class="border-w-2"
        color="primary"
        outlined
        @click="printLabel"
    >
      <v-icon>mdi-printer</v-icon>
      <b>{{ $lang.PRINT }}</b>
    </v-btn>
    <!-- type==2-->
    <v-btn
        v-if="btn_type==2"
        class="download-svg-btn"
        depressed
        height=""
        outlined
        rounded
        width="100px"
        @click="printLabel"
    >
      <v-icon> mdi-printer</v-icon>
      {{ $lang.PRINT }}
    </v-btn>
    <!-- type==3-->
    <v-btn
        v-if="btn_type==3"
        fab
        small
        text
        @click="printLabel"
    >
      <v-icon color="#6D7C8E" small> mdi-printer</v-icon>
    </v-btn>

    <!-- SOURCE -->
    <div v-if="shipment_id_list.length>0" class="">
      <div :id="shipment_id?'printMe-'+shipment_id:'printMe'">
        <section v-for="(values,i) in value_list" :key="values.shipment_id"
                 :class="(i+1)%2==0?'page':'page'"
                 style="padding-left: 6px; width: 335px; height: 340px; overflow-y: hidden;display: inline-block"
        >
          <div style=" padding: 0px 10px 0px 0px;font-family: 'Nunito Sans', sans-serif ;">
            <div style="border-bottom: solid 2px black; ">
              <div style="display:table-cell;width:90px;border-right: solid 2px black;vertical-align: middle;">
                <span style="font-size: 32px;font-family: 'Nunito Sans', sans-serif">MedX</span>
              </div>
              <div style="display:table-cell;padding-left:8px; vertical-align: top">
                <span style="font-size: 12px">From: </span>
              </div>
              <div style="display:table-cell;padding-left:5px;">
                <span style="font-weight: bold;font-size: 12px;">{{ values.wholesaler_name }}</span><br>
                <span style="font-size: 12px;">{{ values.wholesaler_address }}</span><br>
                <span style="font-size: 12px;">{{ values.wholesaler_phone_number }}</span>
              </div>
            </div>

            <table style="width:100%;border-collapse:collapse; margin-bottom: 0px">
              <tr style="border-bottom: solid 2px black">
                <td colspan="3">
                  <span style="font-size: 10px">To : </span><br>
                  <span style="font-weight: bold; font-size: 12px;">{{ values.retailer_name }}</span><br>
                  <span style="font-size: 12px;">{{ values.retailer_address }}</span><br>
                  <span v-if="values.retailer_phone_number" style="font-size: 13px;">{{
                      values.retailer_phone_number
                    }}</span>
                </td>
                <td style="vertical-align: top; text-align: right; padding:0px 0px;">
                  <span style="color:black;font-size: 4rem;">{{ values.line }}</span>
                </td>
              </tr>
            </table>
            <table style="width:100%;border-collapse:collapse;margin-bottom: 0px;font-size: 12px;">
              <tr style="border-bottom: solid 2px black;vertical-align: top;">
                <td colspan="3" style="padding:4px 0px;">
                  <span style="font-weight: bold">Ch. /B. No.: {{ values.challan_number }} </span><br>
                  <span style="font-weight: bold">Amount: {{ values.amount }}</span>
                </td>
                <td style="text-align: right; padding:4px 0px 0px 0px;">
                  <p style="margin-top:0px; margin-bottom:5px; font-weight: bold ">Package
                    {{ values.current_package_count }}
                    of {{ values.package_count }}
                  </p>
                  <span style="font-weight: bolder; font-size: 14px;">{{ values.payment_mode }}</span>
                </td>
              </tr>
            </table>
            <table style="width:100%;border-collapse:collapse;">
              <tr>
                <td style="text-align: center;">
                  <img :src="values.barcode" style="width: 100%;height: 75px;"/>
                </td>
                <td><span
                    style="writing-mode: vertical-rl;font-weight: normal; font-size: 12px;margin-left: -24px">{{
                    values.id
                  }}</span>
                </td>
              </tr>
            </table>
            <div>
            </div>
            <p style="text-align: center; margin-top: -3px"><small>Time : {{ values.created }}
            </small>
            </p>

          </div>
          <!--          <div v-if="(i+1)%2!=0" style="margin-bottom: 10px"></div>-->
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['shipment_id_list', "btn_type", "shipment_id"],
  data() {
    return {
      value_list: [],
      shipment_ids: []
    }
  },
  created() {
    this.shipment_ids = this.$route.params.id
    // this.getPdfData()
  },
  methods: {
    async print() {
      console.log(this.$htmlToPaper)
      // Pass the element id here
      await this.$htmlToPaper('printMe');
    },
    printLabel() {
      if (this.shipment_id_list.length == 0) {
        this.showSnakeBar("warning", this.$messages.NO_SHIPMENT_SELECTED);
        return false;
      }
      if (JSON.parse(this.shipment_id_list).length >8) {
        this.showSnakeBar("warning", this.$messages.MAX_SHIPMENT_SELECTED);
        return false;
      }
      // this.$router.push({name: "shipping-label", params: {id: this.shipment_id_list}})
      let routeData = this.$router.resolve({name: "shipping-label", params: {id: this.shipment_id_list}});
      window.open(routeData.href, '_blank');

    },
    getPdfData() {
      // let shipment_id_list = []
      // if (this.shipment_id) {
      //   shipment_id_list.push(this.shipment_id)
      //   shipment_id_list = JSON.stringify(shipment_id_list)
      // } else
      //   shipment_id_list = this.shipment_id_list

      // if (this.shipment_id_list.length == 0) {
      //   this.showSnakeBar("warning", this.$messages.NO_SHIPMENT_SELECTED);
      //   return false;
      // }
      const self = this;
      let params = {
        shipment_id_list: JSON.stringify(this.shipment_id_list)
      };
      const successHandler = (response) => {
        if (response.data.success) {
          self.value_list = response.data.value_list.value_list
        }
      };
      const finallyHandler = () => {
        self.table_loading = false;
        this.$store.dispatch("setPageLoader", false);
        if (this.shipment_id)
          this.$htmlToPaper('printMe-' + this.shipment_id);
        else
          this.$htmlToPaper('printMe');
      };
      self.request_GET(
          self,
          this.$urls.BASE_URL + "shipment/get-bulk-pdf/",
          params,
          successHandler,
          null,
          null,
          finallyHandler
      )
      ;
    },
  }
}
</script>
